/**
 * Aura background using pre-softened radial gradients instead of CSS blur filters.
 * Safari's `filter: blur()` is very expensive on large elements — by using wider
 * gradients with softer falloff we get the same visual result with zero blur cost.
 */
const ORB_BASE: React.CSSProperties = {
  willChange: 'transform',
  transform: 'translateZ(0)',
  borderRadius: '50%',
  position: 'absolute' as const,
}

type Orb = {
  size: number
  rgb: string
  peak: number
  mid: number
  midStop?: number
  endStop?: number
  top?: string
  bottom?: string
  left?: string
  right?: string
}

const ORBS: Orb[] = [
  {
    size: 600,
    top: '-18%',
    right: '-28%',
    rgb: '160,50,220',
    peak: 0.55,
    mid: 0.2,
  },
  {
    size: 550,
    top: '22%',
    left: '-23%',
    rgb: '175,75,251',
    peak: 0.6,
    mid: 0.2,
  },
  {
    size: 450,
    bottom: '-3%',
    left: '22%',
    rgb: '100,50,255',
    peak: 0.5,
    mid: 0.18,
  },
  {
    size: 500,
    top: '-3%',
    left: '2%',
    rgb: '130,40,200',
    peak: 0.45,
    mid: 0.15,
  },
  {
    size: 520,
    bottom: '7%',
    right: '-13%',
    rgb: '54,0,220',
    peak: 0.5,
    mid: 0.18,
  },
  {
    size: 400,
    top: '37%',
    left: '27%',
    rgb: '120,20,180',
    peak: 0.4,
    mid: 0.12,
    midStop: 30,
    endStop: 50,
  },
]

export default function ProgramSignupAuraBackground() {
  return (
    <div
      className="pointer-events-none absolute inset-0 z-0 overflow-hidden"
      aria-hidden="true"
    >
      {ORBS.map(
        ({ size, rgb, peak, mid, midStop = 35, endStop = 55, ...pos }, i) => (
          <div
            key={i}
            style={{
              ...ORB_BASE,
              width: size,
              height: size,
              ...pos,
              background: `radial-gradient(circle, rgba(${rgb},${peak}) 0%, rgba(${rgb},${mid}) ${midStop}%, rgba(${rgb},0) ${endStop}%)`,
            }}
          />
        ),
      )}
    </div>
  )
}
